<template>
    <div>
        <template v-if="!loading">

            <!--<template v-if="!checked">-->
            <template>
                <template v-if="taxonomy==='woa' || taxonomy==='weibo'||taxonomy==='live'||taxonomy==='video'||taxonomy==='xhs'">
                    <el-popover v-if="!loading" placement="top" width="160" trigger="hover">

                        <slot v-if="taxonomy==='woa'" style="display:flex">
                            <el-button type="primary" size="small" class="price-btn" plain @click="handleChange($event,true,'top')" :disabled="quote.price==0">头条：{{showPrice(quote.price)}}</el-button>
                            <el-button type="primary" size="small" class="price-btn" plain @click="handleChange($event,true,'non_top')" :disabled="quote.price_second==0">非头条：{{showPrice(quote.price_second)}}</el-button>
                        </slot>

                        <slot v-if="taxonomy==='weibo'" style="display:flex">
                            <el-button type="primary" size="small" class="price-btn" plain @click="handleChange($event,true,'tweet')" :disabled="quote.price==0">直发：{{showPrice(quote.price)}}</el-button>
                            <el-button type="primary" size="small" class="price-btn" plain @click="handleChange($event,true,'retweet')" :disabled="quote.price_second==0">转发：{{showPrice(quote.price_second)}}</el-button>
                        </slot>

                        <slot v-if="taxonomy==='live'" style="display:flex">
                            <el-button type="primary" size="small" class="price-btn" plain @click="handleChange($event,true,'online')" :disabled="quote.price==0">线上活动：{{showPrice(quote.price)}}</el-button>
                            <el-button type="primary" size="small" class="price-btn" plain @click="handleChange($event,true,'offline')" :disabled="quote.price_second==0">下线转发：{{showPrice(quote.price_second)}}</el-button>
                        </slot>

                        <slot v-if="taxonomy==='video'" style="display:flex">
                            <el-button type="primary" size="small" class="price-btn" plain @click="handleChange($event,true,'original_publish')" :disabled="quote.price==0">原创发布：{{showPrice(quote.price)}}</el-button>
                            <el-button type="primary" size="small" class="price-btn" plain @click="handleChange($event,true,'publish')" :disabled="quote.price_second==0">发布：{{showPrice(quote.price_second)}}</el-button>
                        </slot>


                         <slot v-if="taxonomy==='xhs'" style="display:flex">
                            <el-button type="primary" size="small" class="price-btn" plain @click="handleChange($event,true,'video')" :disabled="quote.price==0">视频：{{showPrice(quote.price)}}</el-button>
                            <el-button type="primary" size="small" class="price-btn" plain @click="handleChange($event,true,'imagetext')" :disabled="quote.price_second==0">图文：{{showPrice(quote.price_second)}}</el-button>
                        </slot>

                        <slot v-if="!checked" style="display:flex">
                          <el-button slot="reference" class="cart-cb-btn" icon="iconfont el-icon-plus" circle size="mini"></el-button>
                        </slot>
                        <slot v-else style="display:flex">
                          <el-button slot="reference" class="cart-cb-btn" type="primary" icon="iconfont el-icon-plus" circle size="mini"></el-button>
                        </slot>

                    </el-popover>
                </template>

                <template v-else>
                    <el-button slot="reference" class="cart-cb-btn" @click="handleChange($event,true)" icon="iconfont el-icon-plus" circle size="mini"
                        :disabled="disabled"></el-button>
                </template>

            </template>

            <!--<el-button v-else class="cart-cb-btn" type="primary" icon="iconfont el-icon-plus" circle size="mini" @click="handleChange($event,false)"></el-button>-->

        </template>

        <el-button v-else class="cart-cb-btn" icon="el-icon-loading" circle size="mini"></el-button>

        <!--抛物线小球-->
        <CartBalls ref="ball" :avatar="avatar"/>
    </div>

</template>
<style>
    .cart-cb-btn {
        padding: 4px !important;
    }

    .cart-cb-btn .el-icon-plus {
        font-size: 16px !important;
        font-weight: bold !important;
        color: #eeeeee;
    }

    .el-button--primary.cart-cb-btn .el-icon-plus {
        color: #fff;
    }

    .price-btn {
        width: 100%;
        margin-left: 0 !important;
    }

    .price-btn:first-child {
        margin-bottom: 12px
    }

</style>
<script>
    export default {
        props: ["checked", "taxonomy", "resource_id", "cart", "disabled", "quote","avatar"],
        data() {
            return {
                dialogVisible: false,
                loading: false
            };
        },
        computed: {
            _checked: {
                set(value) {
                    //this.$emit("checked", value ? {} : null);
                },
                get() {
                    return this.checked;
                }
            }
        },
        created() {
            this.$on('batchSubmit', this.batchSubmit);
        },
        methods: {
            drop (target) {
                this.$refs.ball.drop(target)
            },
            showPrice(v) {
                return v == 0 ? '-' : (v + '元')
            },
            //批量加入购物车，当前只支持新闻
            batchSubmit(resource_ids, taxonomy, callback) {
                const loading = this.$loading({
                    lock: true,
                    text: '正在批量添加媒体到购物车，请稍等...',
                });

                this.$http
                    .post("/cart", {
                        resource_ids: resource_ids,
                        taxonomy: taxonomy
                    })
                    .then(response => {})
                    .catch()
                    .then(() => {
                        loading.close();
                        this.$event_bus.$emit(taxonomy+"CartLoad");
                        if (callback) {
                            callback()
                        }
                    });
            },
            handleChange(event,v, type) {

                const params = {
                    resource_id: this.resource_id,
                    taxonomy: this.taxonomy,
                    type: type || ''
                };

                if (v) {
                    this.loading = true;

                    //动画
                    this.$refs.ball.drop(event.target)

                    this.$http
                        .post("/cart", params)
                        .then(response => {
                            if (response.success) {
                                this.$emit("checked", {
                                    item_id: response.data.item_id
                                });
                                this.$event_bus.$emit(this.taxonomy+"CartLoad");
                                this.$store.commit('changeCartTaxonomy',this.taxonomy)
                            } else {
                                this.$alert(response.message||'连接超时，请重新再试', "操作失败", {
                                    type: "error"
                                });
                            }
                        })
                        .catch()
                        .then(() => {
                            this.loading = false;
                        });
                } else {
                    if (!this.cart) {
                        return false;
                    }

                    this.loading = true;

                    this.$http
                        .delete("/cart/" + this.cart.item_id)
                        .then(response => {
                            if (response.success) {
                                this.$emit("checked", null);

                                this.$event_bus.$emit(this.taxonomy+"CartLoad");
                                this.$store.commit('changeCartTaxonomy',this.taxonomy)
                            } else {
                                this.$alert(response.message, "失败", {
                                    type: "error"
                                });
                            }
                        })
                        .catch()
                        .then(() => {
                            this.loading = false;
                        });
                }
            }
        }
    };

</script>



// WEBPACK FOOTER //
// src/components/resource/ResItemSelect.vue